import FieldNames from '../defaults/FieldNames.json';
import { setDataset, setProject, setProjectDiscoveryDates, setProjectFireCodes, setProjectIDs } from '../redux/slices/filterSlice';
import { setViewingActions, setViewingProjects } from '../redux/slices/menuSlice';
import ErrorService from '../services/ErrorService';
import UserHelperService from '../services/UserHelperService';
import { formatDateForDisplay, getSaveableDate } from './DateHelper';
import { getFilterState, getMenuState, getProjectState, updateStore } from './ReduxHelper';

export function getUpdatedUserInfo(userIDUpdate, guid, currentUserInfo, setModifiedBy, setModifiedOn, setCreatedBy, setCreatedOn, createdBy, 
    firstNameUpdate, lastNameUpdate, emailUpdate, nifcUsernameUpdate, userIsActiveUpdate, userIsAdminUpdate, userIsFuelsUpdate, 
    userIsPostFireUpdate, userDefaultAppUpdate, userObjectIDUpdate, isTribalUserUpdate, createdOn, idVal){
    let newUserID;
    if(userIDUpdate){
      newUserID = userIDUpdate;
    } else {
      newUserID = guid;
    }

    var currDate = getSaveableDate(new Date());
    setModifiedBy(currentUserInfo[FieldNames.userFields.nifcUsername])
    setModifiedOn(formatDateForDisplay(currDate));
    if(!createdBy)
    {
      setCreatedBy(currentUserInfo[FieldNames.userFields.nifcUsername])
      setCreatedOn(formatDateForDisplay(currDate));
    }

    const userInfo = {
      [FieldNames.userFields.id]: idVal,
      [FieldNames.userFields.firstName]: firstNameUpdate,
      [FieldNames.userFields.lastName]: lastNameUpdate,
      [FieldNames.userFields.email]: emailUpdate,
      [FieldNames.userFields.nifcUsername]: nifcUsernameUpdate,
      [FieldNames.userFields.isActive]: userIsActiveUpdate,
      [FieldNames.userFields.isAdmin]: userIsAdminUpdate,
      [FieldNames.userFields.isFuels]: userIsFuelsUpdate,
      [FieldNames.userFields.isPostFire]: userIsPostFireUpdate,
      [FieldNames.userFields.defaultApp]: userDefaultAppUpdate,
      [FieldNames.userFields.objectID]: userObjectIDUpdate,
      [FieldNames.userFields.userID]: newUserID,
      [FieldNames.userFields.isTribalUser]: isTribalUserUpdate,
      [FieldNames.userFields.createdBy]: createdBy ? createdBy: currentUserInfo[FieldNames.userFields.nifcUsername],
      [FieldNames.userFields.createdOnDate]: createdBy ? createdOn: currDate,
      [FieldNames.userFields.lastModifiedBy]: currentUserInfo[FieldNames.userFields.nifcUsername],
      [FieldNames.userFields.lastModifiedDate]: currDate,
    }
    return userInfo;
}

export async function getUserRoles(rootServiceUrl, config, idVal, newUserID, departmentSelection, agencySelection, regionSelection, 
  unitSelection, role, selectedRole, subUnitSelection, tribeSelection){
    return new Promise((resolve, reject) => {
      let allUserRoles = [];
      const departmentItems = (departmentSelection && departmentSelection.Department) ? departmentSelection.Department : "";
      const agencyItems = (agencySelection && agencySelection.Agency) ? agencySelection.Agency : "";
      const regionNames = (regionSelection && regionSelection.length > 0) ? regionSelection.map(x => x.Region) : [];
      const unitNames = (unitSelection && unitSelection.length > 0) ? unitSelection.map(x => x.Unit) : [];
      const roleCode = (role && selectedRole) ? role.code : "";
      const subUnitItems = subUnitSelection;
      const tribeItem = (tribeSelection && tribeSelection[FieldNames.units.tribeFullName]) ? tribeSelection[FieldNames.units.tribeFullName] : "";
      if(!departmentItems || !agencyItems || !(regionNames && regionNames.length > 0)){
          //No Department or No Agency - Very simple case
          const userRole = {
            [FieldNames.userRoles.appRole]: roleCode,
            UserID: newUserID,
            [FieldNames.userRoles.usersJoinID]: idVal,
            Department: departmentItems,
            Agency: agencyItems,
            Region: "",
            Unit: "",
            SubUnit: "",
            UnitType: "",
            Tribe: ""
          }
          resolve([userRole]);
      } else {
        //Must have at least a department and an agency to get here
        if(agencyItems === FieldNames.agencies.blm && unitNames && unitNames.length > 0){
          //Checking selected SubUnits - Note: Need Units to be able to select SubUnits
          UserHelperService.getSubUnitsForUnitsByUnits(unitNames).then(subUnitsWithUnits => {
            subUnitItems.forEach(subUnitItem => {
              //Go through all SubUnits selected and get the correct line item for that one. Add these for saving
              const itemToSave = subUnitsWithUnits.filter(x => x[FieldNames.units.subUnit] === subUnitItem[FieldNames.units.subUnit]);
              if(itemToSave && itemToSave.length > 0){
                const userRole = {
                  [FieldNames.userRoles.appRole]: roleCode,
                  UserID: newUserID,
                  [FieldNames.userRoles.usersJoinID]: idVal,
                  Department: itemToSave[0][FieldNames.units.department],
                  Agency: itemToSave[0][FieldNames.units.agency],
                  Region: itemToSave[0][FieldNames.units.region],
                  Unit: itemToSave[0][FieldNames.units.unit],
                  SubUnit: itemToSave[0][FieldNames.units.subUnit],
                  UnitType: itemToSave[0][FieldNames.units.unitType],
                  Tribe: ""
                }
                allUserRoles.push(userRole);
              }
            });
    
            //Now check to see if any units are selected that don't have an associated subUnit
            let userRoleUnits = [];
            if(allUserRoles && allUserRoles.length > 0){
              userRoleUnits = allUserRoles.map(x => x[FieldNames.userRoles.unit]);
            }
            unitNames.forEach(unitItem => {
              if(userRoleUnits && !userRoleUnits.includes(unitItem)){
                let unitItemToSave = subUnitsWithUnits.filter(x => x[FieldNames.units.unit] === unitItem && x[FieldNames.units.subUnit] === "");
                let unitTypeValue = "";
                if(unitItemToSave && unitItemToSave.length > 0){
                  //There are Units in the db without a subUnit
                  unitTypeValue = unitItemToSave[0][FieldNames.units.unitType];
                } else {
                  //If there isn't an entry for that Unit without a subUnit just grab the line item for the correct Unit
                  unitItemToSave = subUnitsWithUnits.filter(x => x[FieldNames.units.unit] === unitItem);
                }
                const userRole = {
                  [FieldNames.userRoles.appRole]: roleCode,
                  UserID: newUserID,
                  [FieldNames.userRoles.usersJoinID]: idVal,
                  Department: unitItemToSave[0][FieldNames.units.department],
                  Agency: unitItemToSave[0][FieldNames.units.agency],
                  Region: unitItemToSave[0][FieldNames.units.region],
                  Unit: unitItem,
                  SubUnit: "",
                  UnitType: unitTypeValue,
                  Tribe: ""
                }
                allUserRoles.push(userRole);
              }
            });
            
            //Now check to see if any regions exist that don't have an associated Unit - Note: If they don't have an associated Unit then they won't have an associated SubUnit
            //All entries in the database have at least a Unit
            if(regionNames && regionNames.length > 0){
              let userRoleRegions = [];
              if(allUserRoles && allUserRoles.length > 0){
                userRoleRegions = allUserRoles.map(x => x[FieldNames.userRoles.region]);
              }
              regionNames.forEach(regionItem => {
                if(userRoleRegions && !userRoleRegions.includes(regionItem)){
                  const regionItemToSave = subUnitsWithUnits.filter(x => x[FieldNames.units.region] === regionItem);
                  if(!regionItemToSave || regionItemToSave.length === 0){
                    //We have a region that doesn't have any units - If it did have units it would be take care of above
                    const userRole = {
                      [FieldNames.userRoles.appRole]: roleCode,
                      UserID: newUserID,
                      [FieldNames.userRoles.usersJoinID]: idVal,
                      Department: subUnitsWithUnits[0][FieldNames.units.department],
                      Agency: subUnitsWithUnits[0][FieldNames.units.agency],
                      Region: regionItem,
                      Unit: "",
                      SubUnit: "",
                      UnitType: "",
                      Tribe: ""
                    }
                    allUserRoles.push(userRole);
                  } 
                }
              });
            } 
            resolve(allUserRoles);
            //addUserRoles(allUserRoles, isUpdate, dbSavedUserRoles, isUserDirty, isUserSuccess);
          }).catch(error => {
            reject(error);
          });
        } else if(agencyItems && agencyItems.includes(FieldNames.agencies.bia) && unitNames && unitNames.length > 0) {
          //Checking selected Tribe
          UserHelperService.getTribesForUnitsByUnits(unitNames).then(tribesWithUnits => {
              //Get the correct line item for the selected tribe. Add these for saving
              const itemToSave = tribesWithUnits.filter(x => x[FieldNames.units.tribeFullName] === tribeItem);
              if(itemToSave && itemToSave.length > 0){
                const userRole = {
                  [FieldNames.userRoles.appRole]: roleCode,
                  UserID: newUserID,
                  [FieldNames.userRoles.usersJoinID]: idVal,
                  Department: itemToSave[0][FieldNames.units.department],
                  Agency: itemToSave[0][FieldNames.units.agency],
                  Region: itemToSave[0][FieldNames.units.region],
                  Unit: itemToSave[0][FieldNames.units.unit],
                  SubUnit: "",
                  UnitType: itemToSave[0][FieldNames.units.unitType],
                  Tribe: itemToSave[0][FieldNames.units.tribeFullName]
                }
                allUserRoles.push(userRole);
              }
    
            //Now check to see if any units are selected that don't have an associated tribe
            let userRoleUnits = [];
            if(allUserRoles && allUserRoles.length > 0){
              userRoleUnits = allUserRoles.map(x => x[FieldNames.userRoles.unit]);
            }
            unitNames.forEach(unitItem => {
              if(userRoleUnits && !userRoleUnits.includes(unitItem)){
                let unitItemToSave = tribesWithUnits.filter(x => x[FieldNames.units.unit] === unitItem && x[FieldNames.units.tribeFullName] === "");
                let unitTypeValue = "";
                if(unitItemToSave && unitItemToSave.length > 0){
                  //There are Units in the db without a tribe
                  unitTypeValue = unitItemToSave[0][FieldNames.units.unitType];
                } else {
                  //If there isn't an entry for that Unit without a tribe just grab the line item for the correct Unit
                  unitItemToSave = tribesWithUnits.filter(x => x[FieldNames.units.unit] === unitItem);
                }
                const userRole = {
                  [FieldNames.userRoles.appRole]: roleCode,
                  UserID: newUserID,
                  [FieldNames.userRoles.usersJoinID]: idVal,
                  Department: unitItemToSave[0][FieldNames.units.department],
                  Agency: unitItemToSave[0][FieldNames.units.agency],
                  Region: unitItemToSave[0][FieldNames.units.region],
                  Unit: unitItem,
                  SubUnit: "",
                  UnitType: unitTypeValue,
                  Tribe: ""
                }
                allUserRoles.push(userRole);
              }
            });
    
            //Now check to see if any regions exist that don't have an associated Unit - Note: If they don't have an associated Unit then they won't have an associated tribe
            //All entries in the database have at least a Unit
            if(regionNames && regionNames.length > 0){
              let userRoleRegions = [];
              if(allUserRoles && allUserRoles.length > 0){
                userRoleRegions = allUserRoles.map(x => x[FieldNames.userRoles.region]);
              }
              regionNames.forEach(regionItem => {
                if(userRoleRegions && !userRoleRegions.includes(regionItem)){
                  const regionItemToSave = tribesWithUnits.filter(x => x[FieldNames.units.region] === regionItem);
                  if(!regionItemToSave || regionItemToSave.length === 0){
                    //We have a region that doesn't have any units - If it did have units it would be take care of above
                    const userRole = {
                      [FieldNames.userRoles.appRole]: roleCode,
                      UserID: newUserID,
                      [FieldNames.userRoles.usersJoinID]: idVal,
                      Department: tribesWithUnits[0][FieldNames.units.department],
                      Agency: tribesWithUnits[0][FieldNames.units.agency],
                      Region: regionItem,
                      Unit: "",
                      SubUnit: "",
                      UnitType: "",
                      Tribe: ""
                    }
                    allUserRoles.push(userRole);
                  } 
                }
              });
            } 
            resolve(allUserRoles);
          }).catch(error => {
            reject(error);
          });
        } else {
          //Can't have units without at least 1 region, can have a region that has no units selected
          //If the region doesn't exist in the db they shouldn't be able to ever select it from the dropdown
          if(regionNames && regionNames.length > 0){
            UserHelperService.getRolesByAgenciesRegions([agencyItems], regionNames).then(unitsWithRegions => {
              unitNames.forEach(unitItem => {
                //Will only be one per unit
                const itemToSave = unitsWithRegions.filter(x => x[FieldNames.units.unit] === unitItem);
                if(itemToSave && itemToSave.length > 0){
                  const userRole = {
                    [FieldNames.userRoles.appRole]: roleCode,
                    UserID: newUserID,
                    [FieldNames.userRoles.usersJoinID]: idVal,
                    Department: itemToSave[0][FieldNames.units.department],
                    Agency: itemToSave[0][FieldNames.units.agency],
                    Region: itemToSave[0][FieldNames.units.region],
                    Unit: itemToSave[0][FieldNames.units.unit],
                    SubUnit: "",
                    UnitType: itemToSave[0][FieldNames.units.unitType],
                    Tribe: ""
                  }
                  allUserRoles.push(userRole);
                }
              });
              //Now check to see if there are any selected regions without a unit
              let userRoleRegions = [];
              if(allUserRoles && allUserRoles.length > 0){
                userRoleRegions = allUserRoles.map(x => x[FieldNames.userRoles.region]);
              }
              regionNames.forEach(regionItem => {
                if(userRoleRegions && !userRoleRegions.includes(regionItem)){
                  const regionItemToSave = unitsWithRegions.filter(x => x[FieldNames.units.region] === regionItem);
                  if(regionItemToSave && regionItemToSave.length > 0){
                    //Only need the first item as all of the rows with the same region will have the same agency and department
                    const userRole = {
                      [FieldNames.userRoles.appRole]: roleCode,
                      UserID: newUserID,
                      [FieldNames.userRoles.usersJoinID]: idVal,
                      Department: regionItemToSave[0][FieldNames.units.department],
                      Agency: regionItemToSave[0][FieldNames.units.agency],
                      Region: regionItem,
                      Unit: "",
                      SubUnit: "",
                      UnitType: "",
                      Tribe: ""
                    }
                    allUserRoles.push(userRole);
                  }
                }
              });
              resolve(allUserRoles);
            }).catch(error => {
              reject(error);
            });
          } 
        }
      }
    });
}

export function getSuccessfulNewRoles(results, allUserRoles){
  let roleCount = 0;
  let allSuccessfulNewRoles = [];
  results.forEach(val => {
    if(val.success){
      allUserRoles[roleCount][FieldNames.userRoles.objectID] = val.objectId;
      allSuccessfulNewRoles.push(allUserRoles[roleCount]);
    }
  });
  return allSuccessfulNewRoles;
}

export function validateCacheByProfile(userInfo) {
  const isUserFuels = userInfo[FieldNames.userFields.isPostFire] === FieldNames.yesNo.yes;
  const isUserPostfire = userInfo[FieldNames.userFields.isPostFire] === FieldNames.yesNo.yes;
  const isFuelsOnly = isUserFuels && !isUserPostfire;
  const isPostFireOnly = !isUserFuels && isUserPostfire;
  const isFuelsAndPostFire = isUserFuels && isUserPostfire;
  const filterState = getFilterState();
  const menuState = getMenuState();
  if(filterState.dataset === FieldNames.datasets.both && !isFuelsAndPostFire)
  {
    const adjustedDataset = isFuelsOnly ? FieldNames.datasets.fuels : FieldNames.datasets.postfire;
    updateStore(setDataset, adjustedDataset);
    if(isFuelsOnly && filterState.project?.length > 0)
    {
      updateStore(setProject, []);
      updateStore(setProjectDiscoveryDates, []);
      updateStore(setProjectIDs, []);
      updateStore(setProjectFireCodes, []);
    }
  }
  if(isFuelsOnly)
  {
    if(filterState.dataset === FieldNames.dataset.postfire)
    {
      updateStore(setDataset, FieldNames.datasets.fuels);
      updateStore(setProject, []);
      updateStore(setProjectDiscoveryDates, []);
      updateStore(setProjectIDs, []);
      updateStore(setProjectFireCodes, []);
    }
    // Note: The following is temporary until Fuels allows Projects
    if(menuState.viewingProjects)
    {
      updateStore(setViewingActions, true);
      updateStore(setViewingProjects, false);
    }
  }
  if(isPostFireOnly)
  {
    if(filterState.dataset === FieldNames.dataset.fuels)
    {
      updateStore(setDataset, FieldNames.datasets.postfire);
    }
  }
}